module.exports = __webpack_public_path__ + "1bdb79e7711d6cf0cd533051cb00afff.png";